/* eslint camelcase: 0 */
import { UpstreamGatewayBase } from './base'
import { toRecruitmentProps } from './translator/recruitment'
import { toUpstreamQueryProps, toQueryProps } from './translator/query'
import { GetRecruitment, FetchRecruitment } from '@/infrastructure/network/Upstream/requests/recruitment'
import { IRecruitmentProps, EmptyRecruitmentPropsFactory } from '@/entities/Upstream/Recruitment'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'

export default class Recruitment extends UpstreamGatewayBase {
  async GetRecruitment(id: string): Promise<IRecruitmentProps> {
    const { recruitment } = await this.apiClient.request(new GetRecruitment(id))
    return recruitment ? toRecruitmentProps(recruitment) : EmptyRecruitmentPropsFactory()
  }

  async FetchRecruitment(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRecruitment(toUpstreamQueryProps(query)))
    return EmptyResponsePropsFactory({
      items: response.recruitments.map((prop) => toRecruitmentProps(prop)),
      query: { ...query, ...toQueryProps(response.query) }
    })
  }
}
